<template>
  <div class="stock-industry-view">
    <StockIndustry />
  </div>
</template>

<script>
import StockIndustry from '@/components/screening/StockIndustry.vue'

export default {
  name: 'StockIndustryView',
  components: {
    StockIndustry
  }
}
</script>

<style scoped>
.stock-industry-view {
  padding: 20px;
  flex: 1;
}
</style>
